import {
    SET_ACCESS_TOKEN,
    SET_PASSWORD,
    SET_PASSWORD_ERROR,
    SET_USER_DETAILS,
    SET_USERNAME,
    SET_USERNAME_ERROR,
} from "@redux/constants";

export const setUserName = (username) => ({
    type: SET_USERNAME,
    payload: username,
});

export const setPassword = (password) => ({
    type: SET_PASSWORD,
    payload: password,
});

export const setAccessToken = (token) => ({
    type: SET_ACCESS_TOKEN,
    payload: token,
});

export const setUserNameError = (boolean) => ({
    type: SET_USERNAME_ERROR,
    payload: boolean,
});

export const setPasswordError = (token) => ({
    type: SET_PASSWORD_ERROR,
    payload: token,
});

export const setUserDetails = (details) => ({
    type: SET_USER_DETAILS,
    payload: details,
});
